// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"65b90450","205":"b38cc079","396":"ac45d291","481":"7637b7c5","695":"14151ad1","954":"9e7835f3","974":"488801b2"}[chunkId] + ".chunk.js";
};